<div class="sw-cms-el-moorl-default">
    <div>{{ $tc(element.label) }}</div>
</div>